const baseTitle = document.title;

let observer;
let root;
let syncScheduled = false;

function syncDocumentTitle() {
	syncScheduled = false;

	const heading = root.querySelector('h1');
	const headingText = heading?.textContent?.trim();

	document.title = headingText ? `${baseTitle} - ${headingText}` : baseTitle;
}

function scheduleSync() {
	if (syncScheduled) {
		return;
	}

	syncScheduled = true;
	queueMicrotask(syncDocumentTitle);
}

// Keeps document.title in sync with the first <h1> rendered inside `target`,
// covering both route changes and headings that appear later (async data).
export function watchDocumentTitle(target) {
	if (observer || !target) {
		return;
	}

	root = target;
	syncDocumentTitle();

	observer = new MutationObserver(scheduleSync);
	observer.observe(root, {
		childList: true,
		subtree: true,
		characterData: true,
	});
}

export function unwatchDocumentTitle() {
	observer?.disconnect();
	observer = null;
}
